import React from 'react';
import {BaseIconProps} from '../../types';

export const BaseDoorstep: React.FC<BaseIconProps> = ({color, size}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 1.5C4.17157 1.5 3.5 2.17157 3.5 3V6.44097C3.36731 6.32221 3.19209 6.25 3 6.25C2.58579 6.25 2.25 6.58579 2.25 7V9C2.25 9.41421 2.58579 9.75 3 9.75C3.19209 9.75 3.36731 9.67779 3.5 9.55903V14.441C3.36731 14.3222 3.19209 14.25 3 14.25C2.58579 14.25 2.25 14.5858 2.25 15V17C2.25 17.4142 2.58579 17.75 3 17.75C3.19209 17.75 3.36731 17.6778 3.5 17.559V21C3.5 21.8284 4.17157 22.5 5 22.5H12.0415C12.0142 22.3374 12 22.1704 12 22V21H5V3H18V15H19.5V3C19.5 2.17157 18.8284 1.5 18 1.5H5ZM13 11.25C12.5858 11.25 12.25 11.5858 12.25 12C12.25 12.4142 12.5858 12.75 13 12.75H14.25V14C14.25 14.4142 14.5858 14.75 15 14.75C15.4142 14.75 15.75 14.4142 15.75 14V12C15.75 11.5858 15.4142 11.25 15 11.25H13ZM15 16.5C14.1716 16.5 13.5 17.1716 13.5 18V22C13.5 22.8284 14.1716 23.5 15 23.5H20C20.8284 23.5 21.5 22.8284 21.5 22V18C21.5 17.1716 20.8284 16.5 20 16.5H15ZM15 22V18H20V22H15Z"
        fill={color}
      />
    </svg>
  );
};
